import { render } from "./LineParallax.vue?vue&type=template&id=1cf873d2&ts=true"
import script from "./LineParallax.vue?vue&type=script&lang=ts"
export * from "./LineParallax.vue?vue&type=script&lang=ts"

import "./LineParallax.vue?vue&type=style&index=0&id=1cf873d2&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__